import { useCallback } from "react";
import { NumberInput } from "components/common/NumberInput";
import { AXES } from "./constants";
import type { Vec3 } from "types/documentation";
import { AxisIndex, FrameVec3EditorSectionProps } from "./types";

export const FrameVec3EditorSection = ({
  title,
  vector,
  fieldKey,
  step,
  onChange,
}: FrameVec3EditorSectionProps) => {
  const setAxisValue = useCallback(
    (index: AxisIndex, value: number) => {
      const next: Vec3 = [...vector] as Vec3;
      next[index] = value;
      onChange(fieldKey, next);
    },
    [vector, fieldKey, onChange]
  );

  return (
    <div className="mb-5">
      <div className="text-xs font-semibold text-gray-700 mb-2">{title}</div>
      <div className="space-y-3 min-w-[220px]">
        {AXES.map(({ label, index }) => (
          <div key={`${fieldKey}-${label}`}>
            <label className="block text-xs text-gray-600 mb-1">{label}</label>
            <NumberInput
              value={vector[index]}
              step={step}
              onChange={(number) => setAxisValue(index, number)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
